export default __webpack_public_path__ + "static/media/optos.c379cabf.svg";